<script setup>
defineProps([
  "name",
  "division",
  "specialty",
  "role",
  "mobile",
  "mobileUrl",
  "phone",
  "phoneUrl",
  "email",
  "imageUrl",
  "location",
]);

const specialtyClass = (s) =>
  s ? `specialty-badge--${s.toLowerCase().replace(/[^a-z]/g, "-")}` : "";
</script>

<template>
  <div
    class="card underwriters col-4 col-md-2 my-2 mr-1 animate__animated animate__fadeIn"
  >
    <img
      class="card-img-top"
      :src="require(`@/assets/img/pen/${imageUrl}.jpg`)"
      :alt="name + ' - ' + role + ' - ' + division + ' insurance'"
    />
    <div class="card-body">
      <h5 class="card-title name highlight mb-2">{{ name }}</h5>
      <span
        v-if="specialty"
        class="specialty-badge mb-2"
        :class="specialtyClass(specialty)"
        >{{ specialty }}</span
      >
      <p v-else class="division mb-2">{{ division }}</p>
      <p class="m-0 role">
        <em>{{ role }}</em>
      </p>
      <!-- <p class="m-0">
        <a :href="`tel:${mobileUrl}`">{{ mobile }}</a>
      </p> -->
      <p class="m-0 phone">
        <a :href="`tel:${phoneUrl}`">{{ phone }}</a>
      </p>
      <p class="m-0 email">
        <a :href="`mailto:${email}`">Email</a>
      </p>
    </div>
  </div>
</template>

<style scoped>
.specialty-badge {
  display: inline-block;
  font-size: 0.85rem;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 5px;
  margin-bottom: 6px;
  letter-spacing: 0.02em;
}

.specialty-badge--professional-indemnity {
  background-color: rgba(97, 40, 118, 0.1);
  color: #612876;
}

.specialty-badge--cyber {
  background-color: rgba(235, 113, 36, 0.1);
  color: #eb7124;
}

.specialty-badge--d-o {
  background-color: rgba(71, 92, 250, 0.1);
  color: #475cfa;
}
</style>
